import { Box, Container, Text } from '@chakra-ui/react';
import LeaderVideo from '../LeaderVideo';

const HearFromLeaders = () => (
  <Container maxW="container.lg">
    <Box padding={{ xs: '50px 0px', md: '100px 50px 56px' }} mt="10px">
      <Text
        fontWeight="700"
        fontSize={{ xs: '26px', md: '36px' }}
        lineHeight="130%"
        color="#197542"
        textAlign="left"
        mb="4rem"
        borderLeft="3px solid #197542"
        pl="10px"
      >
        Hear from Industry Leaders
      </Text>
      <LeaderVideo />
    </Box>
  </Container>
);

export default HearFromLeaders;
